import { DateTime } from 'luxon';

export function dateFilter(value: string | Date): string | null {
    if (value == null) {
        return null;
    }

    if (value instanceof Date) {
        return DateTime.fromJSDate(value).toLocal().setLocale('en-gb').toLocaleString();
    }

    return DateTime.fromISO(value, { zone: 'UTC' }).toLocal().setLocale('en-gb').toLocaleString();
}
export function dateTimeFilter(value: string | Date): string | null {
    if (value == null) {
        return null;
    }

    if (value instanceof Date) {
        return DateTime.fromJSDate(value).toLocal().setLocale('en-gb').toLocaleString(DateTime.DATETIME_SHORT);
    }

    return DateTime.fromISO(value, { zone: 'UTC' }).toLocal().setLocale('en-gb').toLocaleString(DateTime.DATETIME_SHORT);
}
export function timeFilter(value: string | Date): string | null {
    if (value == null) {
        return null;
    }

    if (value instanceof Date) {
        return DateTime.fromJSDate(value).toLocal().setLocale('en-gb').toLocaleString(DateTime.TIME_24_SIMPLE);
    }

    return DateTime.fromISO(value, { zone: 'UTC' }).toLocal().setLocale('en-gb').toLocaleString(DateTime.TIME_24_SIMPLE);
}
export function singleLineAddress(value: null | { addressLine1: string | null, addressLine2: string | null, addressLine3: string | null, town: string | null, county: string | null, postcode: string | null }): string {
    if (value == null) {
        return '';
    }

    const parts = new Array<string>();

    if (value.addressLine1 != null && value.addressLine1.trim() !== '') {
        parts.push(value.addressLine1);
    }

    if (value.addressLine2 != null && value.addressLine2.trim() !== '') {
        parts.push(value.addressLine2);
    }

    if (value.addressLine3 != null && value.addressLine3.trim() !== '') {
        parts.push(value.addressLine3);
    }

    if (value.town != null && value.town.trim() !== '') {
        parts.push(value.town);
    }

    if (value.county != null && value.county.trim() !== '') {
        parts.push(value.county);
    }

    if (value.postcode != null && value.postcode.trim() !== '') {
        parts.push(value.postcode);
    }

    return parts.join(', ');
}
export function padLeft(value: string | number | null, size: number, character: string): string {
    if (value == null) {
        return '';
    }

    value = value.toString();

    return value.padStart(size, character);
}
export function byteToKb(value: number): string {
    const kb = value / 1024;

    return kb.toFixed(2) + 'Kb';
}

export function percentageFilter(value: number): string {
    return `${value.toFixed(1)}%`;
}

export function decimalFilter(value: number, fractionDigits: number): string {
    return value.toFixed(fractionDigits);
}

export function currencyFilter(value: number | null): string {
    if (value == null) {
        return '';
    }

    return `${Math.abs(value).toFixed(2)}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

export function capitalizeFilter(value: string): string {
    return value.replace(/\w{3,}/g, (match) =>
        match.replace(/\w/, (m) => m.toUpperCase()));
}
